<template>
  <div style="padding: 16px;background-color: #EDF0F5">
    <div>请填写体检预约信息：</div>
    <van-form ref="healthFormInfo" @failed="onFailed" @submit="onSubmit">
      <!-- 通过 pattern 进行正则校验 -->
      <van-field v-model="name" :border="false" :rules="[{ required: true, message: '请填写用姓名' }]" label="姓名" name="name"
        required />
      <van-field :border="false" label="性别" name="sex" required>
        <template #input>
          <van-radio-group v-model="sex" direction="horizontal">
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field :border="false" :rules="[{ required: true, message: '请填写出生日期' }]" :value="birthday" clickable
        label="出生日期" name="birthday" readonly required @click="showCalendar = true" />
      <van-popup v-model="showCalendar" position="bottom">
        <van-datetime-picker :max-date="maxDate" :min-date="minDate" type="date" @cancel="showCalendar = false"
          @confirm="onConfirm" />
      </van-popup>

      <van-field v-model="age" :border="false" :rules="[{ required: true, message: '请填写年龄' },
      { pattern: /^\+?[1-9][0-9]*$/, message: '请正确填写年龄' }]" label="年龄" name="age" required type="digit" />
      <van-field :border="false" label="婚姻状态" name="marriageStatus" required>
        <template #input>
          <van-radio-group v-model="marriageStatus" direction="horizontal">
            <van-radio name="1">已婚</van-radio>
            <van-radio name="2">未婚</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-model="cardId" :border="false" :rules="[{ required: true, message: '请填写身份证号' },
      { pattern: /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)$/, message: '请正确填写身份证号' }]" label="身份证号" name="cardId"
        required />
      <van-field v-model="phone" :border="false" :rules="[{ required: true, message: '请填写手机号码' },
      { pattern: /^\d{11,11}$/, message: '请正确填写手机号' }]" label="手机号码" name="phone" required type="tel" />
      <van-field :border="false" :rules="[{ required: true, message: '请选择体检日期' }]" :value="medicalTime" clickable
        label="体检日期" name="medicalTime" readonly required @click="medicalShowCalendar = true" />
      <van-calendar v-model="medicalShowCalendar" :default-date="null" :formatter="formatter" :max-date="scheduleMaxDate"
        :min-date="scheduleMinDate" @confirm="medicalOnConfirm" />

    </van-form>
  </div>
</template>

<script>
import { api_get_schedule } from "@/api/goods-api";
import Moment from "moment";

export default {
  name: "HealthForm",

  data() {
    return {
      name: '',
      sex: '1',
      marriageStatus: '1',
      showCalendar: false,
      medicalShowCalendar: false,
      birthday: '',
      age: 0,
      phone: '',
      cardId: '',
      medicalTime: '',
      formChecked: false,
      formData: {},
      scheduleList: [],
      minDate: new Date(1950, 0, 1),
      maxDate: new Date(),
      scheduleMinDate: new Date(),
      scheduleMaxDate: Moment(new Date()).add(60, 'days').toDate(),
    }
  },

  created() {
    const goodsParamsStr = sessionStorage.getItem("bms.goods_detail_params");
    if (goodsParamsStr) {
      const goodsParams = JSON.parse(goodsParamsStr);
      const packageId = sessionStorage.getItem("bms.goods_detail_sn");
      api_get_schedule(goodsParams.orgId, packageId).then(res => {
        this.scheduleList = res.data;
      })
    }
  },

  methods: {
    onConfirm(date) {
      this.birthday = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
      this.showCalendar = false;
    },

    medicalOnConfirm(date) {
      this.medicalTime = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
      this.medicalShowCalendar = false;
    },

    checkForm() {
      this.$refs.healthFormInfo.submit();
    },

    onFailed(errorInfo) {
      this.formChecked = false;
      this.$emit('formCheckedEvent', this.formChecked);
    },

    onSubmit(values) {
      this.formChecked = true;
      this.formData = values;
      this.$emit('formCheckedEvent', this.formChecked, this.formData);
    },

    formatter(day) {
      const dd = this.scheduleList.find(s => Moment(s.date).format('YYYY-MM-DD') === Moment(day.date).format('YYYY-MM-DD'));
      if (dd) {
        if (dd.leftNum > 0) {
          day.bottomInfo = "有号";
        } else {
          day.bottomInfo = "无号";
          day.type = 'disabled';
        }
      } else {
        day.type = 'disabled';
      }

      return day;
    }
  }
}
</script>

<style scoped></style>